import styled from 'styled-components';

import { PaletteColor } from '@utils/types';

export const Wrapper = styled.div<{
  backgroundColor: PaletteColor;
  width?: number;
  iconLocation?: 'right' | 'left';
  animationHeight?: number;
  animationWidth?: number;
}>`
  width: ${({ animationWidth }) => (animationWidth ? animationWidth : 122)}px;
  height: ${({ animationHeight }) =>
    animationHeight ? animationHeight : 22}px;
  display: flex;
  gap: 4px;
  flex-direction: ${({ iconLocation }) =>
    iconLocation === 'right' ? 'row-reverse' : 'row'};
  align-items: center;
  padding: 0 4px;
  border-radius: 4px;
  background-color: ${({ backgroundColor, theme }) =>
    theme.palette[backgroundColor as PaletteColor]};
  overflow: hidden; /* Hide overflow to keep content inside */
`;

export const Text = styled.div<{ color: PaletteColor; detail?: boolean }>`
  /* Add detail prop to style the text */
  font-size: 12px;
  font-weight: bold;
  color: ${({ color, theme }) => theme.palette[color as PaletteColor]};
  display: flex;
  align-items: center;
  justify-content: start;
  text-align: center;
  height: 100%;
  flex: 1; /* Allow flexibility in container space */
  padding-top: ${({ detail }) => (detail ? 'none' : '2px')};
`;

export const Animations = styled.div`
  position: relative;
  height: 22px; /* Fixed height of 20px */
  overflow: hidden;
`;

export const AnimationItem = styled.div<{ animationHeight?: number }>`
  display: block;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  animation: slide 6s infinite;
  height: 100%;

  @keyframes slide {
    0% {
      transform: translateY(0px); /* Start from below */
    }
    50% {
      transform: translateY(0); /* Center */
    }
    100% {
      transform: translateY(-22px); /* Move up */
    }
  }
`;
export const AnimationItemDetail = styled.span<{ animationHeight?: number }>`
  display: block;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  animation: slide 6s infinite;

  @keyframes slide {
    0% {
      transform: translateY(0px); /* Start from below */
    }
    50% {
      transform: translateY(0); /* Center */
    }
    100% {
      transform: translateY(-22px); /* Move up */
    }
  }
`;
export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: bold;
`;
export const AnimationValue = styled.div`
  margin-top: 2px;
`;
export const ContainerAnimation = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
`;
export const BadgeAnimationWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const WrapperAnimation = styled.div<{
  backgroundColor: PaletteColor;
  width?: number;
  iconLocation?: 'right' | 'left';
}>`
  width: ${({ width }) => (width ? `${width}px` : 'auto')};
  height: auto;
  display: flex;
  gap: 4px;
  flex-direction: ${({ iconLocation }) =>
    iconLocation === 'right' ? 'row-reverse' : 'row'};
  align-items: center;

  & li {
    list-style: none !important;
  }

  justify-content: space-between;
  padding: ${({ iconLocation }) => (iconLocation === 'right' ? '6px' : '4px')};
  border-radius: 4px;
  background-color: ${({ backgroundColor, theme }) =>
    theme.palette[backgroundColor as PaletteColor]};
`;

export const TextAnimation = styled.span<{
  color: PaletteColor;
  iconLocation: string;
}>`
  font-size: 12px;
  font-weight: bold;
  color: ${({ color, theme }) => theme.palette[color as PaletteColor]};
`;
export const Animation = styled.div`
  height: 1.2em;
  line-height: 1.2em;
  position: relative;
  overflow: hidden;
  width: 8em;
  > span {
    font-size: 12px;
    position: absolute;
    animation: multi 5s infinite;
    font-weight: 600;
  }

  @keyframes multi {
    0% {
      top: 0;
    }
    25% {
      top: -1.2em;
    }
    50% {
      margin-top: -0;
    }
    75% {
      margin-top: -0;
    }
    100% {
      margin-top: 0;
    }
  }
`;
export const AnimationDescription = styled.div`
  height: 1.2em;
  line-height: 1.2em;
  position: relative;
  overflow: hidden;
  width: 8em;
  > span {
    font-size: 12px;
    position: absolute;
    animation: slide 6s infinite;
    font-weight: 600;
  }

  @keyframes slide {
    0% {
      top: 0;
    }
    25% {
      top: -1.2em;
    }
    50% {
      top: -2.4em;
    }
    75% {
      margin-top: -0;
    }
    100% {
      margin-top: 0;
    }
  }
`;

export const NotAnimation = styled.div`
  height: 1.2em;
  line-height: 1.2em;
  width: 8em;
`;
export const CardText = styled.p`
  margin: 0;
`;

export const IconWrapper = styled.div<{ right: boolean; hasPointer: boolean }>`
  cursor: ${({ hasPointer }) => (hasPointer ? 'pointer' : 'auto')};
`;
